import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {GridComponent} from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import {SharedGrid} from '../../shared/grid.model';
import {ApPriceAlertModel, ApPriceAlertsService} from './ap-price-alerts.service';
import {BaseDashboardComponent} from '../base-dashboard-component';

// Independent of the sidebar filters, so like Route Loops it loads once, the first
// time it is selected, rather than on every filter search
@Component({
    selector: 'app-ap-price-alerts',
    templateUrl: './ap-price-alerts.component.html',
    styleUrls: ['./ap-price-alerts.component.scss']
})
export class ApPriceAlertsComponent extends BaseDashboardComponent implements OnChanges {
    @Input() isVisible = false;
    @ViewChild('grid') grid: GridComponent;
    public tableGrid = new SharedGrid();
    public isLoading = false;
    public moneyCell = {format: '0.00'};
    public dateCell = {format: 'dd/mm/yyyy'};
    private loaded = false;

    constructor(private serv: ApPriceAlertsService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isVisible?.currentValue === true && !this.loaded) {
            this._loadData();
        }
    }

    // The Export button lives in the Key Metrics card header (combo-card-select)
    get canExport(): boolean {
        return !this.isLoading && this.tableGrid.gridData.length > 0;
    }

    exportToExcel() {
        this.grid?.saveAsExcel();
    }

    exportFileName(): string {
        return `ap-price-alerts-${moment().format('YYYY-MM-DD')}.xlsx`;
    }

    _loadData() {
        this.isLoading = true;
        this.loaded = true;
        this.serv.getApPriceAlerts().subscribe(
            (resp: ApPriceAlertModel[]) => {
                this.tableGrid.gridData = resp;
                this.tableGrid.gridSort = [];
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
                console.error('Error occurred loading advanced purchase price alerts', error);
            }
        );
    }
}
